import ajax from '@/libs/api.request'

export default {
  getTeacherList: param => {
    return ajax.post('edu/web/teacher/getTeacherList', param);
  },
  getCourseList: param => {
    return ajax.get('edu/web/teacher/getCourseList');
  },
  getTeacherCourse: param => {
    return ajax.post('edu/web/teacher/getTeacherCourse', param);
  },
  getTeacherBase:param=>{
    return ajax.post('edu/web/teacher/getTeacherBase',param)
  },
  saveTeacher:param=>{
    return ajax.post('edu/web/teacher/saveTeacher',param);
  },
  getAllTeacherCourse:param=>{
    return ajax.post('edu/web/teacher/getAllTeacherCourse',param);
  },
  getAllTeacherCourseTime:param=>{
    return ajax.post('edu/web/teacher/getAllTeacherCourseTime',param);
  },
  getTclass:param=>{
     return ajax.post('edu/web/teacher/getClassListT',param);
  },
  saveHomework:param=>{
    return ajax.post('edu/web/teacher/saveHomework',param);
  },
  changeClass:param=>{
    return ajax.post('edu/web/teacher/changeClass',param);
  },
  delTeacher:param=>{
  return ajax.post('edu/web/teacher/delTeacher',param);
  }
}

